export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('willScrollToInvalidRef', willScrollToInvalidRef)
})

function willScrollToInvalidRef({
  refs = [],
  invalidatedOnly = false,
} = {}): Boolean {
  console.debug(
    '$willScrollToInvalidRef targets: ',
    refs.map((ref: Ref) => ref.value.name),
  )

  const hasInvalid = refs
    .map((ref: Ref) => {
      const target = ref.value
      typeof target?.update === 'function' && target.update()
      const result =
        typeof target?.isInvalid === 'function' ? target.isInvalid() : false
      if (invalidatedOnly) return false
      if (result) console.debug('invalid', target.name)
      return result
    })
    .reduce((a, b) => a || b, false)

  if (hasInvalid) {
    setTimeout(
      () => (document.querySelector('.p-invalid') as HTMLElement)?.focus(),
      100,
    ) //! don't use nextTick. enter key refreshes page.
  }
  return hasInvalid
}
